// extracted by mini-css-extract-plugin
export default {"video":"Home_video__16cHv","overlay":"Home_overlay__qf1Ba"};